import { useEffect } from "react";

import { ReactComponent as AccountBalance } from "../../img/payments/account-balance.svg";
import { ReactComponent as CreditCard } from "../../img/payments/credit-card.svg";
import { ReactComponent as ExternalLink } from "../../img/ExternalLink.svg";
import { ReactComponent as MoneyCashBill } from "../../img/payments/money-cash-bill.svg";
import { smallHeaderTitle } from "../apollo/LocalState";

const PaymentsAndPayouts: React.FC = () => {
  useEffect(() => {
    smallHeaderTitle("Payments & Payouts");
    return () => {
      smallHeaderTitle("");
    };
  }, []);

  return (
    <div className="page-container center-align">
      <div className="page-container-inner padding-bottom-large">
        <div className="header unit-title">
          <MoneyCashBill
            className="payments-and-payouts-header-icon"
            title="Payments & Payouts"
          />
          Payments &amp; Payouts
        </div>
        <div className="margin-top-small" />
        <div className="payments-and-payouts-list">
          <div className="payments-and-payouts-section">
            <p className="menu">Payments</p>
            <div className="payments-and-payouts-section-content">
              <p>
                Add, edit, or remove your payment methods linked to ProView.
              </p>
              <a
                className="payments-and-payouts-link placeholder"
                href="https://google.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="element-tab-port-hidden">
                  Manage Payment Method
                </span>
                <span className="element-tab-port-visible">Learn More</span>
                <ExternalLink />
              </a>
            </div>
          </div>
          <div className="payments-and-payouts-section">
            <p className="menu">Payouts</p>
            <div className="payments-and-payouts-section-content">
              <p>Add, edit, or remove your bank accounts linked to ProView.</p>
              <a
                className="payments-and-payouts-link placeholder"
                href="https://google.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="element-tab-port-hidden">Manage Payouts</span>
                <span className="element-tab-port-visible">Learn More</span>
                <ExternalLink />
              </a>
            </div>
          </div>
          <div className="payments-and-payouts-card">
            <p className="menu">How it works</p>
            <div className="payments-and-payouts-card-row">
              <AccountBalance
                className="payments-and-payouts-card-icon"
                title="Account Balance"
              />
              <div className="payments-and-payouts-card-content">
                <p className="placeholder">Payment</p>
                <p>
                  Save your payment method to subscribe your customers to
                  Brilliant Max. As a pro, you may sell annual subscriptions at
                  $70/year.
                </p>
              </div>
            </div>
            <div className="payments-and-payouts-card-row">
              <CreditCard
                className="payments-and-payouts-card-icon"
                title="Credit Card"
              />
              <div className="payments-and-payouts-card-content">
                <p className="placeholder">Payouts</p>
                <p>
                  Pros receive a commission of 30% when customers are subscribed
                  to Brilliant Max. Payouts are sent out on a monthly basis. In
                  order to receive your payout, you need to have a bank account
                  linked to your ProView account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsAndPayouts;
